module.exports = __webpack_public_path__ + "static/media/telcel-logo.e43ffef7.png";